<template>
  <div class="setting-join-wxapp">
    <div class="module-item-style">
      <div class="module-item-title">微信小程序接入</div>
      <div class="join-tips">
        接入后你可以使用微聊统一接收与回复小程序用户的客服消息。
      </div>
      <div class="wl-btn" @click="toBindWx">接入微信小程序</div>
      <ul class="join-result">
        <li><span>*</span>接入前你的小程序需完成认证；
        </li>
        <li><span>*</span>接入后，所有小程序用户的客服消息会被转发到微聊，微信公众平台网页版客服工具中将不再收到用户消息。</li>
      </ul>
      <ul class="join-content-container">
        <li class="bind-item" v-for="(item, i) in wxAppList" :key="i">
          <div class="join-logo">
            <img src="@/assets/images/wxApp-item.png" alt="">
          </div>
          <div class="join-type-container">
            <div class="bind-name">{{item.wxName}}</div>
            <div class="bind-type">
              绑定模式：<span v-if="item.mode == 'authMode'">授权</span><span v-else>配置</span>
            </div>
          </div>
          <div class="join-operation-container">
            <span class="wl-btn configShop" @click="storeConfig(item)" v-if="item.mode == 'authMode'">店铺配置</span>
            <span class="wl-btn unbind-wl" @click="unbindWL(item.id,item.mode)">解除微聊</span>
          </div>
        </li>
      </ul>
    </div>
    <!--    授权配置-->
    <el-dialog
        title="授权配置"
        width="570px"
        :visible.sync="dialogFormVisible">
      <div>
        <p>小程序第三方平台授权</p>
        <el-input class="appid-input" v-model="appId" placeholder="指定APP ID(必填)"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="toWechat">确 定</el-button>
      </div>
    </el-dialog>
    <!--    店铺配置-->
    <el-dialog
        title="店铺配置"
        class="config-dialog"
        width="570px"
        :before-close="closeDialogHandler"
        :visible.sync="shopConfigVisible">
		<el-popover
		  placement="right"
		  width="400"
		  style="margin-left: 5px;vertical-align: middle;"
		  class="store-remind"
		  trigger="hover">
		  <span style="font-size: 12px;color: #333;">配置以下店铺小程序，可在会话页右侧查看商品、订单、优惠券数据。</span>
		  <span slot="reference"><i class="el-icon-info"></i></span>
		</el-popover>
      <el-form ref="configForm" :model="configForm" label-width="135px">
        <el-form-item label="店铺：">
          <el-select v-model="configForm.domain" placeholder="请选择店铺" style="width: 100%;" @change="domainChange">
            <el-option :label="item.name" :value="item.url" v-for="(item, i) in domainList" :key="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="configForm.domain.length !== 0 || !isStoreProgram">
          <template slot="label">
            <div>app_key
              <svg-icon class="help-icon" @click.native="showHelp('appkey')" icon-class="help"></svg-icon>
              ：
            </div>
          </template>
          <el-input v-model="configForm.app_key" placeholder="请输入店铺KEY"></el-input>
        </el-form-item>
        <el-form-item v-if="configForm.domain.length !== 0 || !isStoreProgram">
          <template slot="label">
            <div>app_secret
              <svg-icon class="help-icon" @click.native="showHelp('appsecret')" icon-class="help"></svg-icon>
              ：
            </div>
          </template>
          <el-input v-model="configForm.app_scrert" placeholder="请输入店铺SECRECT"></el-input>
        </el-form-item>
        <el-form-item v-if="configForm.domain.length === 0 && isStoreProgram">
          <template slot="label">
            <div>域名<svg-icon class="help-icon" @click.native="showHelp('storeProgram')" icon-class="help"></svg-icon>：</div>
          </template>
          <el-input v-model="customDomain" placeholder="请输入店铺域名"></el-input>
        </el-form-item>
      </el-form>
      <el-dialog
          :title="innerTitle"
          class="innerDialog"
          :visible.sync="innerVisible"
          append-to-body>
        <div style="padding-bottom: 10px;">配置界面如下图所示</div>
        <div>
          <img width="100%" :src="helpImage" alt="">
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogHandler">取 消</el-button>
        <el-button type="primary" @click="configConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import appKeyImage from '@/assets/images/app_key.png' // 客满美业
  import appSecretImage from '@/assets/images/app_secret.png' // 客满美业
  import kemanStoreAppKeyImage from '@/assets/images/kemanStore-appkey.png' // 客满云店
  import kemanStoreAppSecretImage from '@/assets/images/kemanStore-appSecret.png' // 客满云店
  import storeProgramImage from '@/assets/images/store_image.png'
  export default {
    name: 'setting-join-wxapp',
    data() {
      return {
        dialogFormVisible: false,
        shopConfigVisible: false,
        innerVisible: false,
        innerTitle: '',
        wxAppList: [],
        domainList: [],
        appId: '',
        bindWay: 1,
        bindcomponentURL: '',
        auth_code: this.$route.query.auth_code,
        expires_in: this.$route.query.expires_in,
        helpImage:'',
        configForm: {
          domain: '',
          app_key:'',
          app_scrert:'',
        },
        isStoreProgram: false,
        customDomain: '',
        gzhId: '',
		currSelectName:"",
      }
    },
    created() {
      this.getWxappList()
      // this.initBindAddr()
    },
    mounted() {
      if (this.auth_code && this.expires_in) {
        this.bindUrlCallback()
      }
    },
    methods: {
      showHelp(type) {
        if(type === 'appsecret'){
          this.innerTitle = 'app_secret配置信息查看'
          this.helpImage = this.currSelectName=="客满云店"? kemanStoreAppSecretImage : appSecretImage
        }else if(type === 'appkey'){
          this.innerTitle = 'app_key配置信息查看'
          this.helpImage = this.currSelectName=="客满云店"? kemanStoreAppKeyImage : appKeyImage
        } else if (type === 'storeProgram') {
          this.innerTitle = '小程序域名配置信息查看'
          this.helpImage = storeProgramImage
        }
        this.innerVisible = true
      },
      storeConfig(item) {
        this.shopConfigVisible = true
        this.gzhId = item.id
        if (item.isStoreProgram) {
          this.configForm = {
            domain: '',
            app_key:item.app_key,
            app_scrert:item.app_scrert,
          }
          this.customDomain = item.wxapp_domain
        } else {
          this.configForm = {
            domain: item.wxapp_domain,
            app_key:item.app_key,
            app_scrert:item.app_scrert,
          }
          this.customDomain = ''
        }

        this.isStoreProgram = item.isStoreProgram
      },
      closeDialogHandler(){
        this.shopConfigVisible = false
      },
      domainChange(selVal){
		let obj = {}
		obj = this.domainList.find(item =>{
			return item.url === selVal
		})
		this.currSelectName = obj.name
        if (this.configForm.domain.length === 0) {
          this.isStoreProgram = true
        } else {
          this.isStoreProgram = false
        }
      },
      configConfirm() {
        if(this.configForm.domain.length === 0 && this.customDomain.length === 0){
          this.$message({
            message: '店铺域名不能为空',
            type: 'error',
          })
          return false
        }
        if(this.configForm.app_key.trim().length === 0 && this.customDomain.length === 0){
          this.$message({
            message: 'app_key不能为空',
            type: 'error',
          })
          return false
        }
        if(this.configForm.app_scrert.trim().length === 0 && this.customDomain.length === 0){
          this.$message({
            message: 'app_scrert不能为空',
            type: 'error',
          })
          return false
        }
        let postData = {
          gzhId:this.gzhId,
          shopUrl:this.configForm.domain.length === 0 ? this.customDomain : this.configForm.domain,
          appKey:this.configForm.app_key,
          appScrert:this.configForm.app_scrert,
        }
        this.$http.setWxAppShopConfigAPI(postData).then( res => {
          if (res.status == 1) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.shopConfigVisible = false
            this.getWxappList()
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })

      },
      toBindWx() {
        this.dialogFormVisible = true
      },
      toWechat() {
        this.initBindAddr()
        // window.location.href = this.bindcomponentURL
      },
      getWxappList() {
        this.$http.getWxAppListAPI().then(res => {
          if (res.status == 1) {
            this.wxAppList = res.data.authMode.concat(res.data.configMode)
            let  shopObj = res.data.shopChoseList
            let shopList =  []
            for (let key in shopObj) {
              let item = {}
              item.name = key
              item.url = shopObj[key]
              shopList.push(item)
            }

            this.domainList = shopList
            console.log(shopList)
          }
        })
      },
      initBindAddr() {
        this.$http.initBindUrlAPI({
          biz_appid: this.appId
        }).then(res => {
          console.log(res);
          if (res.status === "1") {
            window.location.href = res.data.bindcomponentURL
            // this.bindcomponentURL = res.data.bindcomponentURL
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      bindUrlCallback() {
        this.$http.getGzhRedirectUrlAPI({
          "auth_code": this.auth_code,
          "expires_in": this.expires_in,
          "auth_type": "2"
        }).then(res => {
          if (res.status == 1) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
          window.location.href = res.data.redirectUrl
        })
      },
      unbindWL(id, mode) {
        let isAuthMode // 是否是授权模式 1是 0不是(配置模式)
        if (mode == "authMode") {
          isAuthMode = 1
        } else {
          isAuthMode = 0
        }
        let authType = '2' // 1是公众号 2是小程序
        this.$confirm('将要进行解绑操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.unbindWechatAPI({
            gzhId: id,
            authType,
            isAuthMode
          }).then(res => {
            if (res.status == 1) {
              this.getWxappList()
              this.$message({
                message: res.msg,
                type: 'success',
              })
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
              })
            }
          })
        }).catch(() => {
        })
      }
    }
  }
</script>

<style lang="scss">
  .setting-join-wxapp {
    .join-tips {
      font-size: 12px;
      color: #999;
      line-height: 40px;
    }

    .join-result {
      padding: 15px;

      li {
        line-height: 22px;
        padding-bottom: 5px;

        span {
          color: #FF4E00;
          font-size: 16px;
          display: inline-block;
          padding-right: 8px;
        }
      }
    }

    .join-content-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: flex-start;
      padding-left: 0;

      .bind-item {
        width: 48%;
        min-width: 350px;
        font-size: 12px;
        display: flex;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(228, 231, 237, 1);
        border-radius: 6px;
        padding: 15px 10px;
        align-items: center;
        margin-bottom: 10px;

        .join-logo {
          margin-right: 10px;

          img {
            width: 72px;
            height: 40px;
          }
        }

        .join-type-container {
          width: 140px;

          .bind-name {
            padding: 0 5px 8px 0;
            font-size: 14px;
            font-weight: bold;
            line-height: 18px;
          }

          .bind-type {
            font-size: 13px;

            span {
              color: $mainColor;
            }
          }
        }

        .join-operation-container {
          margin-left: auto;

          .wl-btn {
            padding: 0 10px;
          }

          .wl-btn + .wl-btn {
            margin-left: 15px;
          }

          .unbind-wl {
            border: 1px solid #F68541;
            color: #F68541;
            background-color: #fff;
          }

          .configShop {
            border: 1px solid $mainColor;
            color: $mainColor;
            background-color: #fff;
          }
        }
      }
    }

    .bind-way-radio-group {
      width: 100%;
      text-align: center;
    }

    .dialog-footer {
      text-align: center;
    }

    .appid-input {
      margin: 20px auto 0;
    }

    .el-form-item__label {
      color: #333;
      font-weight: bold;
    }

    .config-dialog {
      .help-icon {
        margin-top: 0;
        cursor: pointer;
      }
    }
	.store-remind{
		position: absolute;
		left: 80px;
		top: 24px;
	}
  }
</style>
